import type { Artwork } from "./types";

export const trashWorks: Artwork[] = [
  {
    id: "tr1",
    title: "gun",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/gun.png",
    fullImage: "/gallery/trash/full/gun.png",
    date: "2026-02-14",
  },
  {
    id: "tr2",
    title: "heartopen",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/heartopen.png",
    fullImage: "/gallery/trash/full/heartopen.png",
    date: "2026-02-14",
  },
  {
    id: "tr3",
    title: "houseyUntitled",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/houseyuntitled.png",
    fullImage: "/gallery/trash/full/houseyUntitled.png",
    date: "2026-02-14",
  },
  {
    id: "tr4",
    title: "mspaint",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/mspaint.png",
    fullImage: "/gallery/trash/full/mspaint.png",
    date: "2026-02-14",
  },
  {
    id: "tr5",
    title: "Photo 2026-02-13, 10 46 32 PM (1)",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/photo-2026-02-13-10-46-32-pm-1.jpg",
    fullImage: "/gallery/trash/full/Photo 2026-02-13, 10 46 32 PM (1).jpg",
    date: "2026-02-13",
  },
  {
    id: "tr6",
    title: "Photo 2026-02-13, 10 46 32 PM (2)",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/photo-2026-02-13-10-46-32-pm-2.jpg",
    fullImage: "/gallery/trash/full/Photo 2026-02-13, 10 46 32 PM (2).jpg",
    date: "2026-02-13",
  },
  {
    id: "tr7",
    title: "Photo 2026-02-13, 10 46 32 PM (3)",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/photo-2026-02-13-10-46-32-pm-3.jpg",
    fullImage: "/gallery/trash/full/Photo 2026-02-13, 10 46 32 PM (3).jpg",
    date: "2026-02-13",
  },
  {
    id: "tr8",
    title: "Photo 2026-02-13, 10 46 32 PM",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/photo-2026-02-13-10-46-32-pm.jpg",
    fullImage: "/gallery/trash/full/Photo 2026-02-13, 10 46 32 PM.jpg",
    date: "2026-02-13",
  },
  {
    id: "tr9",
    title: "Untitled_Artwork 1",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-1.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 1.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr10",
    title: "Untitled_Artwork 10",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-10.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 10.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr11",
    title: "Untitled_Artwork 11",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-11.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 11.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr12",
    title: "Untitled_Artwork 12",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-12.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 12.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr13",
    title: "Untitled_Artwork 13",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-13.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 13.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr14",
    title: "Untitled_Artwork 3",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-3.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 3.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr15",
    title: "Untitled_Artwork 4",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-4.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 4.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr16",
    title: "Untitled_Artwork 5",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-5.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 5.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr17",
    title: "Untitled_Artwork 6",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-6.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 6.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr18",
    title: "Untitled_Artwork 7",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-7.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 7.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr19",
    title: "Untitled_Artwork 8",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-8.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 8.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr20",
    title: "Untitled_Artwork 9",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork-9.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork 9.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr21",
    title: "Untitled_Artwork",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/untitled-artwork.jpg",
    fullImage: "/gallery/trash/full/Untitled_Artwork.jpg",
    date: "2026-02-14",
  },
  {
    id: "tr22",
    title: "zap",
    year: 2026,
    medium: "trash",
    thumbnail: "/gallery/trash/thumbs/zap.png",
    fullImage: "/gallery/trash/full/zap.png",
    date: "2026-02-14",
  },
];
